import { get } from 'lodash';
function getPdfUrl(contact, coreUrl) {
  var url = get(contact, 'consent.file_uploads[0].path', '');
  return "".concat(coreUrl).concat(url);
}
export default getPdfUrl;
//# sourceMappingURL=getPdfUrl.js.map